/**
 * CargoProductsModal — página completa de Productos embebida en un Dialog.
 *
 * Se abre cuando un producto no es encontrado en SmartGT.
 * Pre-carga el buscador con el nombre del producto y permite buscar, editar o crear productos.
 */

import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog"
import { AlertTriangleIcon } from "lucide-react"
import { CargoProductsTable } from "@/pages/cargos/CargoProductsTable"

interface Props {
  open: boolean
  onClose: () => void
  defaultSearch?: string
}

export function CargoProductsModal({ open, onClose, defaultSearch = "" }: Props) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose() }}>
      <DialogContent className="max-w-5xl w-full max-h-[90vh] flex flex-col p-0 gap-0">
        <DialogHeader className="px-6 pt-5 pb-4 border-b shrink-0">
          <DialogTitle>Productos</DialogTitle>
          {defaultSearch && (
            <div className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-800 px-3 py-2 text-sm text-amber-800 dark:text-amber-300 mt-2">
              <AlertTriangleIcon className="size-4 shrink-0" />
              <span>
                El producto{" "}
                <span className="font-semibold underline uppercase">{defaultSearch}</span>{" "}
                no está registrado. Buscá el producto y editala para agregar este código SGT, o creá uno nuevo.
              </span>
            </div>
          )}
        </DialogHeader>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          <CargoProductsTable defaultSearch={defaultSearch} hideHeader />
        </div>
      </DialogContent>
    </Dialog>
  )
}
